import React from 'react';
import { useHistory } from 'react-router-dom';
import { MetaTags } from 'react-meta-tags';
import { Container, Row, Col } from 'reactstrap';
import { DashBreadcrumb } from '../../components/Common/Breadcrumb';
import { Toaster } from 'react-hot-toast';
import ComplaintsDoForm from './ComplaintsDoForm';

const ComplaintsDoPage = () => {
  const history = useHistory();

  const handleClose = () => {
    history.push('/Complaints/complaint-do-list');
  };

  const handleSuccess = () => {
    history.push('/Complaints/complaint-do-list');
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>DO</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col>
              <DashBreadcrumb
                title="Complaints"
                breadcrumbItem="DO"
              />
            </Col>
          </Row>
          <ComplaintsDoForm onClose={handleClose} onSuccess={handleSuccess} />
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default ComplaintsDoPage;
